/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-09 13:25:09
 */

import React, { Component } from "react";
import { Spin } from "antd";
import Flags from "../country-flags/Flags";
import * as handler from "../utils/handler";
const queryString = require("query-string");

class ModalHead extends Component {
  changeLocationUrl = window["app-config"].URL.changeLocationUrl;
  defaultLanguage = window["app-config"].defaultLang;
  runApp = window["app-config"].runApp;
  logo = window["app-config"].ui.logo;
  headerBackGround = window["app-config"].ui.header.backGroundColor;
  headerFontColor = window["app-config"].ui.header.fontColor;

  state = {
    lang: {},
  };

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
  }

  render() {
    if (this.props.heading !== null) {
      return (
        <div
          className="sl__modal--title"
          style={{
            background: this.headerBackGround,
            color: this.headerFontColor,
          }}
        >
          <div className="sl__modal--toggle-title">
            <div>
              <div
                style={{
                  width: "45%",
                  display: "block",
                  margin: "0 auto",
                }}
              >
                <h2>
                  <span className="sl__modal--store-name booked">
                    {this.props.heading}
                  </span>
                </h2>
              </div>
              {this.logo.showLogo === true ? (
                <img
                  className="head-logo"
                  style={{
                    float: this.logo.float,
                    marginTop: this.logo.marginTop,
                  }}
                  src={process.env.PUBLIC_URL + `/images/${this.logo.fileName}`}
                />
              ) : null}
            </div>
          </div>
          <Flags heading={this.state.lang.ChooseYourLanguage} />
        </div>
      );
    } else if (this.runApp.toLowerCase() !== "samsung") {
      return (
        <div
          className="sl__modal--title"
          style={{
            background: this.headerBackGround,
            color: this.headerFontColor,
            width: "100%",
          }}
        >
          <div className="sl__modal--toggle-title">
            <div>
              <div
                style={{
                  width: "50%",
                  // backgroundColor: "red",
                  display: "block",
                  margin: "0 auto",
                }}
              >
                <h2>
                  <span className="sl__modal--store-name booked">
                    {/* {this.props.heading} */}
                    {this.state.lang.StaticHeaderHeading}
                  </span>
                </h2>
              </div>
              {this.logo.showLogo === true ? (
                <div className="logo-container">
                  <img
                    className="head-logo"
                    style={{
                      float: this.logo.float,
                      marginTop: this.logo.marginTop,
                    }}
                    height="auto"
                    width="auto"
                    src={
                      process.env.PUBLIC_URL + `/images/${this.logo.fileName}`
                    }
                  />
                </div>
              ) : null}
            </div>
          </div>
          <Flags heading={this.state.lang.ChooseYourLanguage} />
        </div>
      );
    } else {
      return (
        <div
          className="sl__modal--title"
          style={{
            background: this.headerBackGround,
            color: this.headerFontColor,
          }}
        >
          <div className="sl__modal--toggle-title">
            <h2>
              <span className="sl__modal--store-name">
                {this.props.address !== undefined &&
                this.props.address.length > 0 &&
                this.props.address[0] !== null ? (
                  this.props.address[0].BranchTitle + " | "
                ) : (
                  <Spin />
                )}

                {this.props.address !== undefined &&
                this.props.address.length > 0 &&
                this.props.address[0] !== null
                  ? this.props.address[0].Address
                  : null}
              </span>
            </h2>
            {this.runApp === "samsung" ? (
              <a
                id="back-store-selector"
                href={this.changeLocationUrl}
                className="sl__modal--change-location"
                target="_blank"
              >
                {this.state.lang.ChangeLocation}
              </a>
            ) : null}
          </div>
          {this.logo.showLogo === true ? (
            <img
              className="head-logo"
              style={{
                float: this.logo.float,
                marginTop: this.logo.marginTop,
              }}
              src={process.env.PUBLIC_URL + `/images/${this.logo.fileName}`}
            />
          ) : null}
        </div>
      );
    }
  }
}

export default ModalHead;
